import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { ApplicationConfigService } from '../../core/services/application-config.service';
import { Subject } from 'rxjs';
import { PlantingSiteService } from '../../core/services/planting-site.service';

@Component({
    selector: 'app-planting-site-list',
    templateUrl: './planting-site-list.component.html'
})
export class PlantingSiteListComponent implements OnInit {
    pageSize: number;
    sites: PlantingSiteDto[];
    unfilteredSites: PlantingSiteDto[] = [];
    pageSizeUpdate$ = new Subject<number>();
    unfilteredSitesChanged$ = new Subject<PlantingSiteDto[]>();

    constructor(
        private route: ActivatedRoute,
        private siteService: PlantingSiteService,
        private router: Router, 
        private appConfigService: ApplicationConfigService) {
    }

    ngOnInit() {
        this.pageSize = this.appConfigService.plantingSiteListPageSize;
        this.route.data.subscribe(data => {
            this.unfilteredSites = data.plantingSites || [];
        });
        
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    updatePageSize(pageSize: number){
        this.pageSize = pageSize;
        this.appConfigService.updatePlantingSitePageSize(pageSize);
        this.pageSizeUpdate$.next(pageSize);
    }

    async siteDeleted(site: PlantingSiteDto){
        await this.siteService.deletePlantingSite(site.id);
        this.unfilteredSitesChanged$.next(await this.siteService.getAll());
    }
}
